import { render, staticRenderFns } from "./ProfileAva.vue?vue&type=template&id=037dda12&scoped=true"
import script from "./ProfileAva.vue?vue&type=script&lang=ts"
export * from "./ProfileAva.vue?vue&type=script&lang=ts"
import style0 from "./ProfileAva.vue?vue&type=style&index=0&id=037dda12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037dda12",
  null
  
)

export default component.exports